import { createRouter, ErrorComponent } from '@tanstack/react-router';
import { QueryClient } from 'react-query';
import { Page } from './components/page-layout/page';
import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const router = createRouter({
  routeTree,
  defaultPendingComponent: () => <div>Loading</div>,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  defaultNotFoundComponent: () => (
    <Page title='Page Not Found'>
      <a href='/dashboard'>Go Back To Dashboard</a>
    </Page>
  ),
  context: {
    auth: undefined!,
    queryClient,
    user: undefined!,
  },
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
